import {
  TAG_TYPE_NAME,
  TagTypeTagV2,
  UserTagsV2Payload,
  UserTagsV2Response,
} from "@/types/tagsV2";
import { apiClientV2 } from "./apiClientV2";
import { ResponseV2 } from "@/types/responseV2";

const postTagsV2 = (payload: UserTagsV2Payload) =>
  apiClientV2.post<
    ResponseV2<UserTagsV2Response>,
    ResponseV2<UserTagsV2Response>
  >("/tags", payload);

const getTagByTagTypeV2 = (tag_type_name: string) =>
  apiClientV2.get<ResponseV2<TagTypeTagV2>, ResponseV2<TagTypeTagV2>>(
    `/tag-types/${tag_type_name}`
  );

const getTagsByTagTypeV2 = (tag_type_name: string) =>
  apiClientV2.get<ResponseV2<TagTypeTagV2[]>, ResponseV2<TagTypeTagV2[]>>(
    `/tag-types/${tag_type_name}/tags`
  );

const getRegionTags = () => getTagsByTagTypeV2(TAG_TYPE_NAME.REGION);
const getProviderTags = () => getTagsByTagTypeV2(TAG_TYPE_NAME.PROVIDER);
const getCbsaTags = () => getTagsByTagTypeV2(TAG_TYPE_NAME.CBSA);
const getConfidentialityLevelTags = () =>
  getTagsByTagTypeV2(TAG_TYPE_NAME.CONFIDENTIALITY_LEVEL);

const getTagsByTagIdV2 = (tag_type_id: number) =>
  apiClientV2.get<ResponseV2<TagTypeTagV2[]>, ResponseV2<TagTypeTagV2[]>>(
    `/tags/${tag_type_id}/hierarchy`
  );

export const tags = {
  getByTagType: getTagsByTagTypeV2,
  getTagByTagType: getTagByTagTypeV2,
  getByTagId: getTagsByTagIdV2,
  post: postTagsV2,
  platform: {
    getRegionTags,
  },
  mk2: {
    getProviderTags,
    getRegionTags,
  },
  mc: {
    getCbsaTags,
    getConfidentialityLevelTags,
  },
};
